import React, { useState } from 'react';
import { Modal, Form, Input, Select, Image, Button, AutoComplete, Flex } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import type { UploadChangeParam } from 'antd/es/upload';
import type { RcFile, UploadFile } from 'antd/es/upload/interface';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../stores/root-store-context';
import FormItem from 'antd/es/form/FormItem';
import { Ticket } from '../../api/TicketApi';
import { TicketAssignKanban } from '../../stores/TicketStore';

const { TextArea } = Input;
const { Option } = Select;

export interface AssignTicketModalProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  ticket: Ticket;
}


const AssignKanbanTask: React.FC<AssignTicketModalProps> = ({
  visible,
  setVisible,
  ticket,
}) => {

  const { t } = useTranslation();
  const [form] = Form.useForm<TicketAssignKanban>();

  const { applicationStore, projectsStore, employeesStore, kanbanTaskStore, ticketStore } = useStore();
  const currentUser = applicationStore.user;
  const [inputSearchValue, setInputSearchValue] = useState("");


  if (!currentUser) return null;


  const onCancel = () => {
    form.resetFields();
    setVisible(false);
  };

  const onSubmit = (values: TicketAssignKanban) => {
    console.log(values);
    ticketStore.assignKanbanTask(values);
    form.resetFields()
    setVisible(false);
  };


  return (
    <Modal
      title={t('CreateNewTask') + " Kanban"}
      visible={visible}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      footer={null}
      // okText={t('Create')}
      // cancelText={t('Cancel')}
      width={700}
    >
      <Form form={form} layout="vertical"
        onFinish={onSubmit}
        initialValues={{
          kanbanCompanyId: applicationStore.company?.Id,
          ticketPublicId: ticket.publicId,
          description: ticket.description,
          projectId: projectsStore.projects.find(project => project.title.includes("ProductSupport"))?.id
        }}>
        <FormItem name="kanbanCompanyId" hidden>
          <Input hidden />
        </FormItem>
        <FormItem name="ticketPublicId" hidden>
          <Input hidden />
        </FormItem>
        <Form.Item
          name="projectId"
          label={t('Project')}
          rules={[{ required: true, message: t('PleaseSelectProject') }]}
        >
          <Input hidden />
          <AutoComplete
            style={{ height: 40 }}
            placeholder="Project"
            defaultValue={projectsStore.projects.find(project => project.title.includes("ProductSupport"))?.title}
            options={projectsStore.projects
              .filter(
                (project) =>
                  project.isActive !== false &&
                  (project.isPublish ||
                    project.developers.some(d => d.id === currentUser.id)))
              ?.map((el) => ({
                value: el.title,
                label: (
                  <Flex gap={5}>
                    <span>{`${el.title}`}</span>
                  </Flex>
                ),
                data: el,
              }))}
            onChange={(value, option: any) => {
              form.setFieldValue("projectId", option.data?.id);
            }}
            searchValue={inputSearchValue}
            onSearch={(text) => setInputSearchValue(text)}
            filterOption={(inputValue, option) => {

              return (
                option?.value
                  .toUpperCase()
                  .indexOf(inputValue.toUpperCase()) !== -1
              );
            }}

          />
        </Form.Item>

        <Form.Item
          name="assigneeId"
          label={t('Assignee')}
          rules={[{ required: true, message: t('Please select assignee') }]}
        >
          <Input hidden />
          <AutoComplete
            style={{ height: 40, width: "100%" }}
            placeholder={t("User")}
            onChange={(e, option: any) => {
              console.log(option);
              form.setFieldValue("assigneeId", option.id);
            }}
            options={employeesStore.users?.map((el, index) => ({
              value: `${el.firstName} ${el.lastName} ${el.email}`,
              id: el.id, label: <Flex align="center" key={el.id}>
                <Image
                  preview={false}
                  width={40}
                  height={40}
                  style={{ borderRadius: "50%", objectFit: "cover", minWidth: 40 }}
                  src={el.photoId ? `${applicationStore?.siteConfig?.baseCloudinary}/image/upload/w_300/${el.photoId}` :
                    `https://res.cloudinary.com/dnl3x07wo/image/upload/w_300/z03w7hlsy8hcoic9dlcn`
                  }
                />
                <Flex vertical justify="start" gap={5} style={{ marginLeft: 20 }}>
                  <div>{el.firstName + " " + el.lastName}</div>
                  <div>{el.email}</div>
                </Flex>
              </Flex>
            }))}
          />
        </Form.Item>
        <Form.Item
          name="description"
          label={t('Description')}
          rules={[{ required: true, message: t('Please provide a detailed description') }]}
        >
          <TextArea
            rows={6}
            placeholder="Вкажіть детальний опис вашої проблеми..."
          />
        </Form.Item>
        <Form.Item>
          <Flex align='center' justify='end' gap={10}>
            <Button type="default" onClick={onCancel}>
              {t('Cancel')}
            </Button>
            <Button type="primary" htmlType="submit">
              {t('Create')}
            </Button>
          </Flex>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AssignKanbanTask;
